import { Button, ButtonGroup } from '@mui/material'
import { Grid } from '@material-ui/core'
import React, { useMemo, useState } from 'react'
import "./index.scss"
import { format, startOfMonth, subMonths } from "date-fns"
import clsx from 'clsx'
import { ftoDate } from '../../../../util/formatTime'
import { useTranslation } from 'react-i18next'
import { DateRangePicker } from 'rsuite'
import {
  CUSTOM_FILTER_DAY,
  MAX_FILTER_RANGE_DAYS,
  formatLocalDate,
  orderDateRange,
  parseLocalDate,
} from 'util/date'

const getAppliedRange = data => {
  const start = parseLocalDate(data?.date_start)
  const end = parseLocalDate(data?.date_end) || start
  return start && end ? [start, end] : null
}

const formatRangeLabel = (startStr, endStr) => {
  const start = parseLocalDate(startStr)
  const end = parseLocalDate(endStr)
  if (!start || !end) return ''
  return `${ftoDate(start.getDay() + 1)}, ${format(start, 'dd/MM/yyyy')} - ${ftoDate(end.getDay() + 1)}, ${format(end, 'dd/MM/yyyy')}`
}

export default (props) => {
  const { t } = useTranslation()
  const { afterToday, allowedMaxDays, combine } = DateRangePicker
  const appliedRange = useMemo(
    () => getAppliedRange(props.data),
    [props.data.date_start, props.data.date_end],
  )
  const [open, setOpen] = useState(false)

  const lang = window.localStorage.getItem('i18n') || 'vi'
  const calendarLocale = {
    sunday: lang === 'vi' ? 'CN' : 'Su',
    monday: lang === 'vi' ? 'T2' : 'Mo',
    tuesday: lang === 'vi' ? 'T3' : 'Tu',
    wednesday: lang === 'vi' ? 'T4' : 'We',
    thursday: lang === 'vi' ? 'T5' : 'Th',
    friday: lang === 'vi' ? 'T6' : 'Fr',
    saturday: lang === 'vi' ? 'T7' : 'Sa',
  }

  const closePicker = () => setOpen(false)

  const handlePreset = day => {
    closePicker()
    props.changeFilter(day)
  }

  const applyRange = val => {
    const [start, end] = orderDateRange(val?.[0], val?.[1])
    if (!start) {
      closePicker()
      return
    }
    props.changeCustomRange(formatLocalDate(start), formatLocalDate(end))
    setOpen(false)
  }

  const isCustom = props.data.day === CUSTOM_FILTER_DAY || open

  return (
    <Grid
      className="control-panel-col-1"
      container
      xs={12}
      sm={12}
      md={9}
    >
      <Grid className="header-dashboard" item xs={12} sm={12} md={12}>
        <div className="header-block">
          <p className="title-header">{t('overview')}</p>
          <div className="content-filter">
            <span className="text-filter">{formatRangeLabel(props.data.date_start, props.data.date_end)}</span>
            <div className="header-date-picker">
              <ButtonGroup className="btn-filter" color="success" disableElevation variant="outlined" aria-label="outlined button group">
                <Button className={clsx("btn-7-days",{
                  active: !open && props.data.day == 7
                })} onClick={() => handlePreset(7)}>7 {t('day')}</Button>
                <Button className={clsx("btn-15-days",{
                  active: !open && props.data.day == 15
                })} onClick={() => handlePreset(15)}>15 {t('day')}</Button>
                <Button className={clsx("btn-custom",{
                  active: isCustom
                })} onClick={() => setOpen(prev => !prev)}>{t('custom')}</Button>
              </ButtonGroup>
              <DateRangePicker
                className="header-date-picker__input"
                open={open}
                value={appliedRange}
                onOk={applyRange}
                onOpen={() => setOpen(true)}
                onClose={closePicker}
                menuClassName="header-dashboard-daterange-menu"
                defaultCalendarValue={[
                  startOfMonth(subMonths(new Date(), 1)),
                  startOfMonth(new Date()),
                ]}
                isoWeek
                ranges={[]}
                cleanable={false}
                placement="bottomEnd"
                preventOverflow
                container={() => document.body}
                format="dd/MM/yyyy"
                locale={calendarLocale}
                disabledDate={combine(allowedMaxDays(MAX_FILTER_RANGE_DAYS), afterToday())}
              />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}
